module.exports = __webpack_public_path__ + "img/compare2.d12008c3.png";